<button type="button"
        class="aa-btn"
        [ngClass]="btnAspect"
        (click)="onClick()"
        [style.width.px]="btnWidth">
    <span>
        <!-- <i class="far fa-fw fa-2x"
           aria-hidden="true">
        </i>&nbsp; -->
        {{ btnText }}&nbsp;
        <i class="far fa-fw fa-2x"
           [ngClass]="icon"
           aria-hidden="true">
        </i>
    </span>
</button>
